import { createActions } from 'redux-actions';

export default createActions(
  {
    RESET: () => ({}),
    RESET_ACTIVE_PANELS: () => ({}),
    TOGGLE_SIDEBAR: (commandId) => ({ commandId }),
    TOGGLE_OVERLAY: (commandId) => ({ commandId }),
  },
  { prefix: 'COMMAND' }
);
